<template>
    <b-modal ref="profile_modal"
             size="sm"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">
                        BILL № {{this.bill_id}}
					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>


            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">

                            <div class="user_auth pb-5" v-for="gate in gates">
                                <a href="#"
                                   v-on:click.prevent="go_pay(gate)"
                                   :class="gate.view_class"
                                   class="w-100 btn btn-success btn-sm btn-w-m waves-effect waves-themed">
                                    {{__t('GO_PAY_' + gate.type)}}
                                </a>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">

            <div class="modal-footer">

            </div>
        </template>


    </b-modal>
</template>

<script>
    export default {
        name: "choose_payment",
        props : {
            modal_position : {
                type : String,
                default : "left"
            },
        },
        data() {
            return  {
                bill_id : 0,
                is_show_modal : false,
                is_load : false,
                gates : [],
            }
        },
        created() {
            EventBus.$on("show_pay",this.work_click);
            this.load_pay_gates();
        },

        methods : {

            close_modal() {
                this.close()
            },

            close() {
                this.is_show_modal = false;
            },

            work_click(bill_id) {
                this.bill_id = parseInt(bill_id);
                this.is_show_modal = true;
            },

            async load_pay_gates() {
                await api.get('/internal/v1/payment/gates').then(({data}) => {
                    if(data.status == 'operation_success') {
                        this.gates = data.data;
                    }

                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            async go_pay(gate) {
                this.is_load = true;
                await api.get('/internal/v1/payment/gates/'+ gate.id + '/bills/' + this.bill_id).then(({data}) => {
                    this.is_load = false;
                    if(data.status === 'operation_success') {
                        let is_form = data.data.is_form;
                        if(is_form) {
                            $('body').prepend('<div id="way_pay"></div>');
                            $('body').find('#way_pay').html(data.data.form);
                            $('body').find('#way_pay').find('form').submit();
                        }
                        else {
                            window.location.href = data.data.url;
                        }
                    }

                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },


            async go_pay_wayfor_pay() {
                this.is_load = true;
                await api.post('/internal/user/pay/way/' + this.bill_id).then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        let form = data.data.form;
                        if(form != null) {
                            $('body').prepend('<div id="way_pay"></div>');
                            $('body').find('#way_pay').html(form);
                            $('body').find('#way_pay').find('form').submit();
                        }
                    }

                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            async go_pay_mono() {
                this.is_load = true;
                await api.post('/internal/user/pay/mono/'  + this.bill_id).then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        this.is_load = false;
                        window.location.href = data.data.url;
                    }

                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            async go_pay_fondy() {
                this.is_load = true;
                await api.post('/internal/user/pay/fondy/'  + this.bill_id).then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        this.is_load = false;
                        window.location.href = data.data.url;
                    }

                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            async go_pay_liqpay() {

                this.is_load = true;
                await api.post('/internal/user/pay/liqpay/' +  + this.bill_id).then(({data}) => {
                    this.is_load = false;
                    window.location.href = data.data.url;
                }).catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

        },

        computed : {

            dialog_class_draw () {
                if(this.modal_position === "left") {
                    return "modal-dialog-left modal-sm";
                }

                return "modal-dialog-right modal-sm";
            },
        }
    }
</script>

<style scoped>

</style>
